import { render, staticRenderFns } from "./PlannerAndCompany.vue?vue&type=template&id=12740e48&scoped=true&"
import script from "./PlannerAndCompany.vue?vue&type=script&lang=js&"
export * from "./PlannerAndCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12740e48",
  null
  
)

export default component.exports